var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1A3459"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 15H16.8C15.81 15 15 15.81 15 16.8V31.2C15 32.19 15.81 33 16.8 33H31.2C32.19 33 33 32.19 33 31.2V16.8C33 15.81 32.19 15 31.2 15ZM20.4 30.3H17.7V22.2H20.4V30.3ZM19.05 20.67C18.15 20.67 17.43 19.95 17.43 19.05C17.43 18.15 18.15 17.43 19.05 17.43C19.95 17.43 20.67 18.15 20.67 19.05C20.67 19.95 19.95 20.67 19.05 20.67ZM30.3 30.3H27.6V25.53C27.6 24.81 26.97 24.18 26.25 24.18C25.53 24.18 24.9 24.81 24.9 25.53V30.3H22.2V22.2H24.9V23.28C25.35 22.56 26.34 22.02 27.15 22.02C28.86 22.02 30.3 23.46 30.3 25.17V30.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.88ab84685aabc152f9de3285a9b36e4d.svg";
export { ForwardRef as ReactComponent };